import React from "react";
import "../components/Popup.scss";
// import { Link } from "react-router-dom";
import imgCloseIcon from "../images/icon-close.png";

function PopupBio(props) {
  const closeModal = () => {
    props.setTrigger(false);
  };

  return props.trigger ? (
    <div className="popup-wrapper dark-bg">
      <div className={`popup-col ${props.columnPosition} `}>
        <button className="close-btn" onClick={closeModal}>
          <img src={imgCloseIcon} alt="Close button" />
        </button>
        <div className={`lightbox-popup-col-inner ${props.backgroundStyle}`}>{props.children}</div>
      </div>
    </div>
  ) : (
    ""
  );
}

export default PopupBio;
